import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const SocialProof = () => {
  return (
    <section id="depoimentos" className="py-24 bg-bg-page">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-brand-primary mb-4">
            O Que Nossos Alunos Dizem
          </h2>
          <p className="body-medium text-gray-400 max-w-3xl mx-auto">
            Histórias reais de transformação. Pessoas comuns que evoluíram em um lugar incomum.
          </p>
        </div>

        {/* Testimonials Scroll Container (Mobile) / Grid (Desktop) */}
        <div className="flex overflow-x-auto pb-8 gap-6 snap-x snap-mandatory lg:grid lg:grid-cols-3 lg:pb-0 lg:overflow-visible no-scrollbar">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="flex-shrink-0 w-[85vw] sm:w-[350px] lg:w-full snap-center glass-card border-white/5 p-6 md:p-8 rounded-2xl relative group"
            >
              <Quote className="absolute top-4 right-4 w-12 h-12 text-brand-primary/10 group-hover:text-brand-primary/20 transition-colors" />
              
              <div className="flex mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-brand-primary fill-brand-primary" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="body-small text-gray-300 mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center space-x-4 pt-4 border-t border-border-medium">
                <div className="w-12 h-12 bg-secondary-olive rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-brand-primary font-bold text-sm">
                    {testimonial.avatar}
                  </span>
                </div>
                <div>
                  <p className="body-small text-brand-primary font-semibold">
                    {testimonial.name}
                  </p>
                  <p className="caption text-gray-500">
                    {testimonial.profession} • {testimonial.time}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <p className="body-medium text-gray-400">
            <span className="text-brand-primary font-bold">+300 alunos satisfeitos</span> e em constante evolução
          </p>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
